import { httpClient } from '@/shared/api/httpClient';

export type ProdutoResumo = {
  id: string;
  codigo: string;
  nome: string;
  precoCompra: number;
  margemPercentual: number;
  precoUnitario: number;
  estoqueQuantidade: number;
  ativo: boolean;
  /** true enquanto o cadastro/edição não foi confirmado pelo servidor. */
  syncPendente: boolean;
};

export type CriarProdutoRequest = {
  codigo?: string | null;
  nome: string;
  precoCompra: number;
  margemPercentual: number;
  precoUnitario: number;
  quantidadeInicial?: number | null;
};

export type CriarProdutoResponse = { id: string };

export type AtualizarProdutoRequest = {
  nome: string;
  precoCompra: number;
  margemPercentual: number;
  precoUnitario: number;
  ativo: boolean;
};

export const produtosApi = {
  listar: () => httpClient.get<ProdutoResumo[]>('/api/produtos'),
  criar: (cmd: CriarProdutoRequest) =>
    httpClient.post<CriarProdutoResponse>('/api/produtos', cmd),
  atualizar: (id: string, cmd: AtualizarProdutoRequest) =>
    httpClient.put<void>(`/api/produtos/${id}`, cmd),
  excluir: (id: string) => httpClient.delete<void>(`/api/produtos/${id}`),
};
